import React from 'react';
import styled from 'styled-components';

const CollapsedTable = styled.table`
  border-collapse: collapse;
  background: transparent;
  th, td {
    height: 10px;
    width: 30px;
    border: 1px solid white;
  }
`;

const BorderButton = styled.div`
  cursor: pointer;
  padding: 10px;
  box-shadow: ${props => props.selected ? '0px 1px 3px 2px rgba(255,255,255,.3)' : '0px 1px 3px 2px rgba(0,0,0,.3)'};
  border-radius: 5px;

  &:hover {
    box-shadow: 0px 1px 3px 2px rgba(255,255,255,.3);
  }

  &.horizontal {
    ${CollapsedTable} {
      th, td {
        border-left-width: 0;
        border-right-width: 0;
      }
    }
  }

  &.vertical {
    ${CollapsedTable} {
      border: 1px solid white;
      td {
        border-width: 0;
      }
    }
  }
`;

export const AllSidesGrid = ({ selected, onClick }) => {
  return (
    <BorderButton selected={selected} onClick={onClick}>
    <CollapsedTable>
      <tbody>
        <tr>
          <th></th>
          <th></th>
        </tr>
        <tr>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </CollapsedTable>
    </BorderButton>
  );
}

export const HorizontalBorderGrid = ({ selected, onClick }) => {
  return (
    <BorderButton className='horizontal' selected={selected} onClick={onClick}>
    <CollapsedTable>
      <tbody>
        <tr>
          <th></th>
          <th></th>
        </tr>
        <tr>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </CollapsedTable>
    </BorderButton>
  );
}

export const VerticalBorderGrid = ({ selected, onClick }) => {
    return (
      <BorderButton className='vertical' selected={selected} onClick={onClick}>
      <CollapsedTable>
        <tbody>
          <tr>
            <th></th>
            <th></th>
          </tr>
          <tr>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </CollapsedTable>
      </BorderButton>
    );
  }